import { login, logout, getInfo } from '@/api/student/index'
import { getToken, setToken, removeToken } from '@/utils/auth'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    username: '',
    students: [],
    language: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_STUDENTS: (state, students) => {
    state.students = students
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        const { name, avatar, students, username } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_STUDENTS', students)
        commit('SET_USERNAME', username)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const userToken = state.token ? state.token : getToken()
      getInfo(userToken).then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { name, avatar, students, username } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_STUDENTS', students)
        commit('SET_USERNAME', username)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove token first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  exit({ commit, state }) {
    removeToken() // must remove token first
    commit('RESET_STATE')
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove token first
      commit('RESET_STATE')
      resolve()
    })
  },
  setLogin({ commit }, userInfo) {
    const { name, avatar, token } = userInfo
    commit('SET_TOKEN', token)
    setToken(token)
    commit('SET_NAME', name)
    commit('SET_AVATAR', avatar)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js